const Direction = {
    x: 'x',
    y: 'y',
};

const DEFAULT_OPTIONS = {
    smooth: true,
    direction: Direction.y,
    duration: 300, // 动画持续时间（毫秒）
    easing: 'easeInOutQuad', // 缓动函数
};

// 缓动函数
const EASING_FUNCTIONS = {
    linear: t => t,
    easeInOutQuad: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
};

function getTargetPosition(element, direction) {
    if (!element) {
        throw new Error('Target element is required');
    }
    return direction === Direction.x ? element.offsetLeft : element.offsetTop;
}

function getScrollOffset(element, direction) {
    if (!element) {
        throw new Error('Container element is required');
    }
    return direction === Direction.x ? element.scrollLeft : element.scrollTop;
}

function scrollToPosition(element, position, isHorizontal) {
    if (!element) return;

    try {
        if (isHorizontal) {
            element.scrollTo({ left: position, top: 0, behavior: 'auto' });
        } else {
            element.scrollTo({ left: 0, top: position, behavior: 'auto' });
        }
    } catch (error) {
        console.warn('Scroll operation failed:', error);
    }
}

function animateScroll(element, start, end, isHorizontal, options) {
    const { duration, easing } = options;
    const startTime = performance.now();
    const distance = end - start;

    const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const easedProgress = EASING_FUNCTIONS[easing](progress);
        const currentPosition = start + (distance * easedProgress);

        if (progress < 1) {
            scrollToPosition(element, currentPosition, isHorizontal);
            requestAnimationFrame(step);
        } else {
            scrollToPosition(element, end, isHorizontal);
        }
    };

    requestAnimationFrame(step);
}

export function scrollIntoView({ target, container, ...options }) {
    if (!target) {
        console.warn('Target element is required for scrollIntoView');
        return;
    }

    const mergedOptions = { ...DEFAULT_OPTIONS, ...options };
    const { smooth, direction, duration, easing } = mergedOptions;

    const parentEle = container ?? document.documentElement;
    const isHorizontal = direction === Direction.x;

    try {
        const targetPosition = getTargetPosition(target, direction);
        const scrollOffset = getScrollOffset(parentEle, direction);

        if (!smooth) {
            scrollToPosition(parentEle, targetPosition, isHorizontal);
            return;
        }

        animateScroll(parentEle, scrollOffset, targetPosition, isHorizontal, {
            duration,
            easing,
        });
    } catch (error) {
        console.error('Scroll operation failed:', error);
    }
}


export const scrollToElement = ({ target, offset = 0, gridHeight=0, lastScrollYRef, container }) => {
    // 判断滚动方向

    let scrollY = window.scrollY
    if (container) {
        scrollY = container.scrollTop
    }

    const box = container || window

    let y = target.getBoundingClientRect().top + scrollY - offset;
    const isScrollUp = y < lastScrollYRef.current;

    if (y === lastScrollYRef.current) return

    if (isScrollUp) {
        y -= gridHeight;
    }

    const top = Math.max(0, y)

    box.scrollTo({ top, behavior: 'smooth' });
    lastScrollYRef.current = top; // 更新

}